"use client";

import { c as _c } from "react/compiler-runtime";
import { toast } from "sonner";
import { signupFormSchema, type SignupFormData } from "./form-fields";
import { useFormSubmit } from "@/hooks/use-form-submit";
interface UseSignupFormProps {
  onSubmit: (formData: FormData) => Promise<{
    errors?: string[];
    success?: boolean;
    companyName?: string;
    email?: string;
  }>;
}
export const transformer = (data: SignupFormData) => {
  const formData = new FormData();
  formData.append("firstName", data.firstName);
  formData.append("lastName", data.lastName);
  formData.append("email", data.email);
  formData.append("contactNumber", data.contactNumber || "");
  formData.append("businessName", data.businessName);
  formData.append("website", data.website || "");

  // Replace single address with separate fields
  formData.append("street", data.street || "");
  formData.append("city", data.city || "");
  formData.append("zipCode", data.zipCode || "");
  formData.append("country", data.country || "");
  return formData;
};
export const buildDefaultValues = () => {
  return {
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    businessName: "",
    website: "",
    street: "",
    city: "",
    zipCode: "",
    country: ""
  };
};
export function useSignupForm(t0) {
  const $ = _c(7);
  const {
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = buildDefaultValues();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSubmit) {
    t2 = {
      onSubmit,
      schema: signupFormSchema,
      defaultValues: t1,
      transformer
    };
    $[1] = onSubmit;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const formService = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      success: _temp,
      error: _temp2
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const notificationService = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      getSuccessMessage: _temp3,
      getErrorMessage: _temp4
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const i18nService = t4;
  let t5;
  if ($[5] !== formService) {
    t5 = {
      formService,
      notificationService,
      i18nService
    };
    $[5] = formService;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return useFormSubmit(t5);
}
function _temp4() {
  return "Failed to create company. Please try again.";
}
function _temp3() {
  return "Company created successfully!";
}
function _temp2(message_0) {
  return toast.error(message_0);
}
function _temp(message) {
  return toast.success(message);
}